export default function DaytonaLocalAreaSection() {
  return (
    <section id="local-area" className="bg-[#F7F8FA] py-20">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl font-bold text-[#1A365D] mb-4">Daytona Beach Area</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Serving Daytona Beach, Port Orange, Ormond Beach, New Smyrna Beach, and all Volusia County communities.
          </p>
        </div>

        <div className="bg-white rounded-lg p-7 border border-gray-200">
          <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
            <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
            Cities &amp; Communities We Serve
          </h3>
          <div className="space-y-1.5 mb-6">
            {[
              { name: "Daytona Beach", zips: "32114, 32118" },
              { name: "Port Orange", zips: "32127, 32128, 32129" },
              { name: "Ormond Beach", zips: "32174, 32176" },
              { name: "New Smyrna Beach", zips: "32168, 32169" },
              { name: "Holly Hill", zips: "32117" },
              { name: "South Daytona", zips: "32119" },
              { name: "DeLand", zips: "32720, 32724" },
              { name: "Palm Coast", zips: "32137, 32164" },
            ].map((city, i) => (
              <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md">
                <div className="flex items-center gap-2.5">
                  <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                  <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                </div>
                <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-100 pt-5">
            <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
            <div className="flex flex-wrap gap-2">
              {[
                { name: "Melbourne", href: "/melbourne" },
                { name: "Orlando", href: "/orlando" },
                { name: "St. Augustine", href: "/st-augustine" },
                { name: "Jacksonville", href: "/jacksonville" },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                >
                  {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}